// This file was automatically generated from print.growthChart.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.growthChart');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.growthChart.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var cList12643 = opt_data.growthCharts;
  var cListLen12643 = cList12643.length;
  for (var cIndex12643 = 0; cIndex12643 < cListLen12643; cIndex12643++) {
    var cData12643 = cList12643[cIndex12643];
    el8.template.print.growthChart.singleChart(soy.$$augmentData(opt_data, {growthChart: cData12643, index: cIndex12643}), output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.growthChart.valueTable = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table class="growthChartDataTable"><thead><tr><th>Date</th><th>Age</th><th>', soy.$$escapeHtml(opt_data.chartTypeName), '</th>', (opt_data.chartType == 'bmi' && opt_data.dataSrc == 'CDC') ? '<th>Percentile</th>' : '', '</tr></thead><tbody>');
  var patientValueList12656 = opt_data.patientData;
  var patientValueListLen12656 = patientValueList12656.length;
  for (var patientValueIndex12656 = 0; patientValueIndex12656 < patientValueListLen12656; patientValueIndex12656++) {
    var patientValueData12656 = patientValueList12656[patientValueIndex12656];
    output.append('<tr><td>', soy.$$escapeHtml(patientValueData12656.when), '</td><td>', soy.$$escapeHtml(Math.round(patientValueData12656.age * 10) / 10), ' ', soy.$$escapeHtml(opt_data.refInfo.xUnits), '</td><td>', soy.$$escapeHtml(patientValueData12656.value), ' ', soy.$$escapeHtml(opt_data.refInfo.yUnits), '</td>', (opt_data.chartType == 'bmi' && opt_data.dataSrc == 'CDC') ? '<td>' + soy.$$escapeHtml(patientValueData12656.percentile) + '</td>' : '', '</tr>');
  }
  output.append('</tbody></table>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.growthChart.singleChart = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  if (opt_data.now) {
    el8.template.print.currentAsOf(opt_data, output);
  }
  output.append('<h1 class="documentTitle">', soy.$$escapeHtml(opt_data.growthChart.chartTypeName), ' for Age Growth Chart</h1>');
  el8.template.print.patientInfo(opt_data, output);
  output.append('<div class="growthChartWrapper"><div class="chart-holder" data-index="', soy.$$escapeHtml(opt_data.index), '" style="width: 650px; height: 700px; margin-top: 10px;"></div><div class="growthChartLegend"></div></div>');
  if (opt_data.growthChart.patientData.length > 0) {
    el8.template.print.growthChart.valueTable(opt_data.growthChart, output);
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
